module.exports = __webpack_public_path__ + "img/right-arrow-bi.34f539a0.svg";